import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICustomerMoveInSettings } from '../models/CustomerModel';
import { DatePipe } from '@angular/common';
import { CommonMethodService } from '../common-method.service';
import { EModuleType, EnumDiscount } from '../enum';
import { addClass } from '@syncfusion/ej2-base';

@Component({
    selector: 'app-discount-list',
    templateUrl: './discount-list.component.html',
    styleUrls: ['./discount-list.component.scss'],
    standalone: false
})
export class DiscountListComponent {
  EModuleType = EModuleType;
  EnumDiscount = EnumDiscount;

  @Input() moduleType: number;
  @Input() moveInSettings: ICustomerMoveInSettings;
  @Input() LatestURCToDatePlusOne;
  @Input() effectiveDatesList: Array<Date>;
  @Input() stopDatesList: Array<Date>;
  @Input() discounts = [];
  LatestURCToDate: Date;
  expandedDiscountId: number = null;

  @Output() emitupdatedDiscounts: EventEmitter<any> = new EventEmitter<any>();

  datepipe: DatePipe = new DatePipe('en');

  constructor(private commotMethodService: CommonMethodService) { }

  toggleDiscount(discountId: number) {
    this.expandedDiscountId = this.expandedDiscountId === discountId ? null : discountId;
  }

  onDiscCheck(eve, DiscId) {
    const discObj = this.discounts.find(o => o.DiscountId === DiscId);
    const applyMultiDisc = this.moveInSettings.ApplyMultipleDisc;

    const updateDiscount = (ele) => {
      ele.Selected = true;
      if (this.moduleType == EModuleType.MakePayment) {
        if (ele.CategoryId == EnumDiscount.PrePayment) {
          ele['newlyChecked'] = true;
        }
        if (applyMultiDisc) {
          ele.ismodified = true;
        }
      }
    }

    if (eve.target.checked) {
      this.discounts.forEach((ele) => {
        if (ele.DiscountId === DiscId) {
          updateDiscount(ele);
        } else {
          if (!applyMultiDisc) {
            ele.Selected = false;
          }
        }
      });

      if (discObj) {
        discObj.PeriodStartDateTime = this.LatestURCToDatePlusOne && this.LatestURCToDatePlusOne > discObj.PeriodStartDateTime ?
          this.LatestURCToDatePlusOne : discObj.PeriodStartDateTime;
        discObj.StopDate = '';
      }
    } else {
      if (discObj && discObj.isActiveOnLoad) {
        if (this.moduleType == EModuleType.MakePayment) {
          discObj.ismodified = true;
          if (discObj.CategoryId == EnumDiscount.PrePayment) {
            discObj['newlyChecked'] = true;
          }
        }
      }
    }
    this.emitupdatedDiscounts.emit(this.discounts);
  }

  onLoadEffectiveDate(args: any) {
    let currentDate = args.date;
    let effDate = this.LatestURCToDatePlusOne;
    const isSelectableDate = this.checkIfDateSelectable(currentDate, effDate);
    args.isDisabled = !isSelectableDate;
    if (isSelectableDate) {
      addClass([args.element], ['reservationCls']);
      args.element.firstElementChild.setAttribute('title', 'Next Billing Date');
      args.element.setAttribute('title', 'Next Billing Date');
    }
  }

  checkIfDateSelectable(currentDate, effDate) {
    const dateIndex = this.effectiveDatesList.findIndex(o => o.getDate() === currentDate.getDate() && o.getMonth() === currentDate.getMonth());
    return dateIndex !== -1 && currentDate.setHours(0, 0, 0, 0) >= effDate.setHours(0, 0, 0, 0);
  }

  onLoadStopDate(args: any, PeriodStartDateTime, NumberOfPeriods) {
    let currentDate = args.date;
    const dateindex = this.stopDatesList.findIndex(o => o.getDate() === currentDate.getDate()
      && o.getMonth() === currentDate.getMonth());
    let dateObj = this.stopDatesList.find(o => o.getMonth() === currentDate.getMonth());
    if (dateindex === -1) {
      if (currentDate.getMonth() == 1 && currentDate.getDate() == 29 && dateObj && dateObj.getDate() == 28 &&
        this.commotMethodService.isLeapYear(currentDate.getFullYear())) {
      } else {
        args.isDisabled = true;
      }
    } else {
      if (currentDate.getMonth() == 1 && currentDate.getDate() == 28 && dateObj && dateObj.getDate() == 28 &&
        this.commotMethodService.isLeapYear(currentDate.getFullYear())) {
        args.isDisabled = true;
      } else {
        addClass([args.element], ['reservationCls']);
        args.element.firstElementChild.setAttribute('title', 'Next Stop Date');
        args.element.setAttribute('title', 'Next Stop Date');
      }
    }
    this.LatestURCToDate = new Date(this.LatestURCToDatePlusOne);
    this.LatestURCToDate.setDate(this.LatestURCToDate.getDate() - 1);
    if (currentDate.setHours(0, 0, 0, 0) < this.LatestURCToDate.setHours(0, 0, 0, 0) ||
      (currentDate.setHours(0, 0, 0, 0) > this.calculateEndDate(PeriodStartDateTime, NumberOfPeriods))) {
      args.isDisabled = true;
    }
  }


  calculateEndDate(startDate: Date, periods: number) {
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + periods);
    endDate.setDate(endDate.getDate() - 1);
    return endDate.setHours(0, 0, 0, 0);
  }

  maxValueValidate(val, max) {
    return val !== '' && val > max ? max : val;
  }

  disableEnableCheckbox(item) {
    if (item.Section == 2 || item.Section == 3 || !item.enableDisc) {
      return true;
    }
    return false;
  }

  onEffectiveDateChange(eve, DiscId) {
    if (eve && eve.isInteracted) {
      var discList = this.discounts.filter(x => x.DiscountId == DiscId && x.Selected);
      var effectivedatechanged = true;
      if (discList && discList.length > 0) {
        this.discounts.map((ele) => {
          if (ele.DiscountId === DiscId) {
            if (eve.value.toDateString() != new Date(ele.PeriodStartDateTime).toDateString()) {
              ele.PeriodStartDateTime = eve.value;
              ele['effectiveDateChanged'] = true;
            } else {
              effectivedatechanged = false;
            }
          }
        });
        if (effectivedatechanged && EModuleType.MakePayment) {
          this.emitupdatedDiscounts.emit(this.discounts);
        }
      }
    }
  }

  onStopDateChange(eve, DiscId) {
    if (eve && eve.isInteracted) {
      var discList = this.discounts.filter(x => x.DiscountId == DiscId && x.Selected);
      var stopdatechanged = true;
      if (discList && discList.length > 0) {
        this.discounts.map((ele) => {
          if (ele.DiscountId === DiscId) {
            if (!eve.value) {
              ele.StopDate = null;
              ele['DiscountStopped'] = false;
              stopdatechanged = true;
            }
            else if (!ele.StopDate || eve.value.toDateString() != new Date(ele.StopDate).toDateString()) {
              ele.StopDate = eve.value;
              ele['DiscountStopped'] = true;
            }
            else {
              stopdatechanged = false;
            }
          }
        });
        if (stopdatechanged && EModuleType.MakePayment) {
          this.emitupdatedDiscounts.emit(this.discounts);
        }
      }
    }
  }

  onValueChanges(event, item, field) {
    if (this.moduleType == EModuleType.ModifyRental) {
      if (field == 'Discount') {
        item.DiscountValue = event;
      }
      if (field == 'Periods') {
        item.NumberOfPeriods = event;
      }
    }
  }


  onInputChange(event: any, item: any) {
    let inputValue = event.target.value;
    if (!inputValue) {
      return;
    }
    const minValue = 0;
    const maxValue = item.MaxDiscValueAllowed;
    if (parseFloat(inputValue) > maxValue) {
      event.target.value = maxValue;
      item.DiscountValue = maxValue;
    } else if (parseFloat(inputValue) < minValue) {
      event.target.value = minValue;
      item.DiscountValue = minValue;
    } else {
      const [integerPart, decimalPart] = inputValue.split('.');
      if (decimalPart && decimalPart.length > 2) {
        event.target.value = `${integerPart}.${decimalPart.substring(0, 2)}`
      }
    }
  }
}
